<template>
    <div class="d-flex flex-column mx-4 flex-shrink-0">
        <span class="caption text-uppercase text--disabled">Current term</span>
        <span class="text-body-1">
            <b>{{ term || '-' }}</b>
        </span>
    </div>
</template>

<script>
import { DateTime } from 'luxon'

export default {
    name: 'CurrentResourceTerm',
    props: {
        resourcePoolId: {
            type: [String, Number],
            required: true
        }
    },
    data() {
        return {
            ncuLimitWindow: null,
            requestId: 0
        }
    },
    computed: {
        term() {
            if (!this.ncuLimitWindow) return null
            const start = DateTime.fromISO(this.ncuLimitWindow.start_date || '')
            const end = DateTime.fromISO(this.ncuLimitWindow.end_date || '')
            if (!start.isValid || !end.isValid) return null
            return `${start.toISODate()} – ${end.toISODate()}`
        }
    },
    methods: {
        async fetchTerm() {
            const requestId = ++this.requestId
            this.ncuLimitWindow = null
            try {
                const { data } = await this.$axios.get(`/resource/${this.resourcePoolId}/status`)
                if (requestId === this.requestId) {
                    this.ncuLimitWindow = data.subscription_stats?.ncu_limit || null
                }
            } catch {
                // Keep the placeholder when the limit window is unavailable.
            }
        }
    },
    watch: {
        resourcePoolId: {
            handler: 'fetchTerm',
            immediate: true
        }
    },
    beforeDestroy() {
        this.requestId++
    }
}
</script>
